import BaseService from './baseService';

export default class extends BaseService {
    constructor() {
        super("psoResults");
    }

    /**
    * Gets Scenarios
    * @param {Object} filter 
    * @param {number} filter.pageNumber - page number
    * @param {number} filter.pageSize - page size
    * @param {string} filter.searchString - search string
    * @param {number} filter.taskId - task id
    * @returns list of scenario item
    */
    getScenarios = (filter: {
        pageNumber: number;
        pageSize: number;
        searchString: string;
        taskId: number;
    }) => this.httpPostRequest('scenarios', filter);

    /**
    * Gets Files
    * @param {Object} filter 
    * @param {string} filter.searchString - search string
    * @param {number} filter.scenarioId - scenario Id
    * @returns list of file groups items
    */
    getResultFiles = (filter: {
        searchString: string;
        scenarioId: number;
    }) => this.httpPostRequest('files', filter);

    /**
    * Starts Merge process
    * @param {number} scenarioId - scenario Id
    * @returns void
    */
    reMerge = ({ scenarioId }: { scenarioId: number }) => this.httpPostRequest('merge', { scenarioId });

    /**
    * Gets urls for downloading files
    * @param {Object} param
    * @param {number} param.scenarioId - scenario Id
    * @param {Array<string>} param.fileNames - fileNames
    * @returns list of urls
    */
    getDownloadUrls = ({ fileNames, scenarioId }: { fileNames: string[]; scenarioId: number; }) => this.httpPostRequest('download', { fileNames, scenarioId });

    /**
    * Gets info about default template
    * @returns hasTemplate: boolean
    */
    getBaseInfo = () => this.httpGetRequest('');

    /**
    * Gets default template
    * @returns lift of file names in default template
    */
    getTemplate = () => this.httpGetRequest('template');

    /**
    * Saves default template
    * @param {Array<string>} files - list of file names
    * @returns void
    */
    saveTemplate = ({ files }: { files: string[] }) => this.httpPutRequest('template', { files });

    /**
    * Stops merge process
    * @param {number} scenarioId - scenario Id
    * @returns void
    */
    stopJobs = (scenarioId: number) => this.httpPostRequest(`stop/${scenarioId}`);
}